module.exports = {
      id: "app-gallery-usage",
      viewBox: "0 0 161 48",
      url: __webpack_public_path__ + "svg-sprite-a2aa2e5b3e3b70ea2fa34e79b698feaf.svg#app-gallery",
      toString: function () {
        return this.url;
      }
    }